import React from "react";

// The shared header for every page of this app.
//
// BOTH program logos appear together, always. A sponsor may be claiming for
// either program — often they do not know which until they read the reference
// number — so showing one would be wrong on roughly half of all visits.
//
// WHY A WHITE HEADER rather than a colored band: the two logo files have SOLID
// WHITE backgrounds, not transparency. On a colored band they read as pasted-on
// rectangles and need a white plate behind them to look deliberate. Making the
// header itself white is what the artwork actually wants, and it has the useful
// side effect of privileging neither program.
//
// The blue|red rule underneath carries the dual identity with equal weight —
// navy for Boys State, maroon for Girls State, matching the two applicant
// portals' own header colors exactly (PROGRAM_COLOR_PRIMARY in each .env).

export function ProgramHeader({ subtitle }: { subtitle?: string }): React.ReactElement {
  return (
    <header className="bg-white">
      <div className="mx-auto flex max-w-3xl items-center justify-between gap-5 px-4 pt-5">
        <div className="flex items-center gap-4">
          <img
            src="/branding/mdbs-logo.png"
            alt="Maryland Boys State"
            className="h-16 w-auto"
          />
          <img
            src="/branding/mdgs-logo.png"
            alt="Maryland Girls State"
            className="h-16 w-auto"
          />
        </div>
        <div className="text-right">
          <div className="text-base font-bold leading-tight text-slate-900">
            {subtitle ?? "Sponsorship Claim"}
          </div>
          <div className="mt-0.5 text-[11px] font-medium uppercase tracking-wider text-slate-500">
            Maryland Boys &amp; Girls State
          </div>
        </div>
      </div>
      {/*
        Equal halves — neither program leads.

        FULL-BLEED on purpose. A rule constrained to a fixed width overhangs the
        content on the narrow views (the forms are max-w-xl) and falls short on
        the wide one (admin is max-w-5xl), and no single width aligns with all
        three. Edge-to-edge reads as a page divider instead of a misaligned box.
      */}
      <div className="mt-4 flex h-[5px]">
        <span className="flex-1 bg-program" />
        <span className="flex-1 bg-program-alt" />
      </div>
    </header>
  );
}
